import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { stripHtmlAndTruncate } from "../../../utils/Actions/stripHtmlAndTruncate";
import { S3URL } from "../../../data/globalConstants";
import { getBaseDomainFromUrl } from "../../../utils/Actions/getBaseDomainFromUrl";
import { useGuildPath } from "../../../utils/Guild/useGuild";

export default function FooterMediaItem({ item, type, activeGenre }) {
  const guildPath = useGuildPath();
  const [itemTitle, setItemTitle] = useState(null);
  const [itemDescription, setItemDescription] = useState(null);
  const [itemThumbnail, setItemThumbnail] = useState(null);
  const [itemLink, setItemLink] = useState(null);
  const [imgOrientation, setImgOrientation] = useState("landscape");
  useEffect(() => {
    if (!item) return;
    setItemTitle(item?.title);

    if (type === "events") {
      setItemLink("/events/" + item.slug);
      setItemDescription(stripHtmlAndTruncate(item?.body, 44));
    } else {
      setItemDescription(stripHtmlAndTruncate(item?.description, 44));
    }

    if (type === "video") {
      setItemLink(
        guildPath(
          "/" + activeGenre?.slug + "/" + item.showSlug + "/video/" + item.slug,
        ),
      );
      if (item?.thumbnail) {
        setItemThumbnail(S3URL + item?.thumbnail);
      } else {
        setItemThumbnail(
          "https://i.ytimg.com/vi/" + item?.filename + "/maxresdefault.jpg",
        );
      }
    }

    if (type === "press") {
      if (item.url) {
        setItemLink(item.url);
      } else {
        setItemLink(
          guildPath(
            "/" + activeGenre?.slug + "/" + item.showSlug + "/press/" + item.slug,
          ),
        );
      }
      if (item?.thumbnail) {
        setItemThumbnail(S3URL + item?.thumbnail);
        orientImage(S3URL + item?.thumbnail);
      } else {
        setItemThumbnail(S3URL + item?.filename);
        orientImage(S3URL + item?.filename);
      }
    }
  }, [item, type, activeGenre?.slug, guildPath]);

  const orientImage = (url) => {
    (async () => {
      try {
        const o = await getImageOrientation(url);
        setImgOrientation(o);
        // console.log(url, o);
      } catch (e) {
        console.error(e);
      }
    })();
  };

  const getImageOrientation = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const w = img.naturalWidth,
          h = img.naturalHeight;
        resolve(w > h ? "landscape" : w < h ? "portrait" : "square");
      };
      img.onerror = () => reject(new Error("Failed to load image"));
      img.src = url;
    });

  return (
    <Link
      to={itemLink}
      className={"page-sink-item"}
      target={item?.url ? "_blank" : "_self"}
    >
      <div className={"page-sink-item-thumb-container"}>
        <div
          className={"page-sink-item-thumb"}
          style={{
            backgroundImage: `url("${itemThumbnail ? encodeURI(itemThumbnail) : "/img/media-thumb-placeholder-landscape.jpg"}")`,
            backgroundSize:
              imgOrientation === "landscape" ? "cover" : "contain",
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <img src={"/img/media-thumb-placeholder-landscape.jpg"} alt={"NF"} />
        </div>
      </div>
      <div className={"page-sink-item-meta"}>
        <div className={"page-sink-item-title"}>
          {type === "press" && item?.url ? (
            <span className={"show-page-section-item-url"}>
              {getBaseDomainFromUrl(item?.url) + " - "}
            </span>
          ) : null}
          {itemTitle}
        </div>
        <div className={"page-sink-item-description"}>{itemDescription}</div>
      </div>
    </Link>
  );
}
